import { z } from 'zod'
import {
  LONG_STRING_MAX_LENGTH,
  MEDIUM_STRING_MAX_LENGTH,
  SHORT_STRING_MAX_LENGTH,
  SHORTEST_STRING_MAX_LENGTH,
  STRING_MIN_LENGTH,
  TEXT_MAX_LENGTH,
} from './validationConfig'

// The backend GraphQL scalars, the tRPC inputs and the frontend checks all build on this, so they
// trim and count the same way (ADR-0016).
export const boundedString = (maxLength: number, { allowEmpty = false } = {}) => {
  const schema = z.string().trim().max(maxLength)
  return allowEmpty ? schema : schema.min(STRING_MIN_LENGTH)
}

export const shortestStringSchema = boundedString(SHORTEST_STRING_MAX_LENGTH)
export const shortStringSchema = boundedString(SHORT_STRING_MAX_LENGTH)
export const mediumStringSchema = boundedString(MEDIUM_STRING_MAX_LENGTH)
export const longStringSchema = boundedString(LONG_STRING_MAX_LENGTH)
export const textSchema = boundedString(TEXT_MAX_LENGTH)

// A search or a filter: an empty box, or one of only spaces, means "no filter" and reads as null,
// so a client sends the box as it is instead of trimming it and mapping '' to undefined.
export const searchStringSchema = boundedString(MEDIUM_STRING_MAX_LENGTH, {
  allowEmpty: true,
}).transform(value => value || null)
